module.exports = __webpack_public_path__ + "img/symbol.1b9aa990.svg";